// Libellé "Note (pause)" pour les exports de pointages.
// Privilégie pause_detail (calculé et stocké par le backend, source de vérité), sinon dérive un
// libellé approché pour les anciens pointages (avant la centralisation), et conserve la note libre
// éventuelle de l'employé. Utilisé par PointeuseAvancee (export Excel) et ExportsPayroll (export paie).
export function pauseNoteFor(p) {
  const toMin = (t) => { const [h, m] = t.split(':').map(Number); return h * 60 + m; };
  let pause;
  if (p.pause_detail) {
    pause = p.pause_detail; // valeur autoritaire du backend
  } else if (p.pause_debut && p.pause_fin) {
    let d = toMin(p.pause_fin) - toMin(p.pause_debut); if (d < 0) d += 1440;
    pause = `Pause manuelle ${d} min (${p.pause_debut}–${p.pause_fin})`;
  } else if (p.evenement_id || p.evenement_nom) {
    pause = 'Aucune pause auto (événement)';
  } else if (p.heure_arrivee && p.heure_depart) {
    let dur = toMin(p.heure_depart) - toMin(p.heure_arrivee); if (dur < 0) dur += 1440;
    pause = (dur / 60 > 4) ? 'Pause auto 45 min (estimé)' : 'Aucune pause (< 4 h)';
  } else {
    pause = '';
  }
  const freeNote = (p.notes && p.notes !== "Pointage depuis l'application") ? p.notes : '';
  return [pause, freeNote].filter(Boolean).join(' — ');
}
